import { Store } from '@tanstack/store';

export const MobileChatsDrawerStore = new Store<{ open: boolean }>({ open: false });
